// extracted by mini-css-extract-plugin
export default {"root":"subPagesClasses_root__oAGEz"};